import { SidebarPrimaryNavigation } from '@shared/ui/sidebar/sidebar-primary-navigation';
import { Flex } from 'antd';
import { type FC } from 'react';
import { Outlet } from 'react-router-dom';
import { usePrimaryNavigation } from './sidebar-navigation';

export const SidebarLayout: FC = () => {
  const primaryNavigation = usePrimaryNavigation();

  return (
    <Flex style={{ height: '100vh', flexDirection: 'column' }}>
      <Flex flex={1} style={{ overflow: 'hidden' }}>
        <Flex style={{ flexShrink: 0 }}>
          <SidebarPrimaryNavigation primaryNavigation={primaryNavigation} />
        </Flex>

        <Flex style={{ flex: 1, overflow: 'hidden' }}>
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  );
};
